<template>
  <app-layout class="app-selector-template">
    <div class="app-selector-ui" style="margin:20px 0 0">
      <div style="width:200px;display:block;margin:0 auto">
        <i-input
          style="text-align:center;"
          v-model="code"
          placeholder="Enter Code"
          size="large"
          :disabled="isCodeLoading"
        >
          <Button
            :loading="isCodeLoading"
            :disabled="!code"
            @click="appSwitchCode"
            slot="append"
            size="small"
          >
            <b v-if="!isCodeLoading">
              <i class="fas fa-arrow-right" />
            </b>
          </Button>
        </i-input>
      </div>
      <div v-if="getUserBrands.data.data.length > 1">
        <div class="apps-wrapper">
          <div v-for="(item, i) in getUserBrands.data.data" :key="i" class="app">
            <div @click="reRoute(item)" class="pointer">
              <Avatar style="width:80px;height:80px" :src="userDisplayImage(item)" />
              <p style="line-height:15px" align="center">
                <small>{{item.display_name}}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="margin-top: 50px;">
        <h3 align="center">No application available</h3>
      </div>
    </div>
  </app-layout>
</template>

<style lang="scss" scoped>
@media (min-width: 1025px) {
  .app {
    width: 25% !important;
  }
}
@media (min-width: 767px) and (max-width: 1024px) {
  .app {
    width: 25% !important;
  }
}
@media (min-width: 100px) and (max-width: 767px) {
  .app {
    width: 33.33333333333%;
  }
}
.app {
  width: 33.33333333333%;
  height: 160px;
  padding: 10px;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: fit-content;
    margin: 0 auto;
  }
}
.apps-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import Utils from "@/utils.js";
import VueCookie from "vue-cookie";

export default {
  name: "app-selector-ui",
  data() {
    return {
      code: "",
      isCodeLoading: false
    };
  },
  computed: {
    ...mapGetters("brand", ["getUserBrands"]),
    ...mapGetters("user", ["userInfo"])
  },
  methods: {
    ...mapActions("brand", ["getBrandByCode"]),
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "medium");
    },
    reRoute(item) {
      if (VueCookie.get("os_type") === "ios") {
        //trigger ios app switch
        this.iosAppSwitch(item.unique_identifier);
      } else {
        //update cookies related to authentication
        let authCookie = localStorage.getItem(
          Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE"
        );
        localStorage.removeItem(Cons[0].PATHS.NAME + this.$route.params.brandSlug + '_COOKIE')
        localStorage.setItem(
          Cons[0].PATHS.NAME + item.unique_identifier + "_COOKIE",
          authCookie
        );
        //redirect to selected app
        this.$router.replace(`/${item.unique_identifier}`);
        location.reload();
      }
    },
    iosAppSwitch(appSlug) {
      window.webkit.messageHandlers.onNativeCalled.postMessage({
        name: "onSwitchApp",
        params: {
          slug: appSlug
        }
      });
    },
    appSwitchCode() {
      if (!this.code || this.isCodeLoading) return;
      if (VueCookie.get("os_type") === "ios") {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: "onInputAppCode",
          params: {
            code: this.code
          }
        });
      } else {
        // do something on non ios devices here
        this.isCodeLoading = true;
        this.getBrandByCode(this.code)
          .then(res => {
            // if resulting brand id is in the current brand list
            if (
              this.getUserBrands.data.data.filter(brand => {
                return brand.id == res.id;
              }).length > 0
            ) {
              // hide loading, show prompt
              this.isCodeLoading = false;
              this.$store.commit("showNotice", {
                type: "info",
                desc: "App already registered"
              });
            } else {
              // follow brand
              this.$store
                .dispatch("user/followGroups", {
                  ids: res.careplan_id
                })
                .then(res => {
                  // hide loading, reload user brands
                  this.isCodeLoading = false;
                  this.$store.dispatch(
                    "brand/getUserBrands",
                    this.userInfo.id,
                    {
                      root: true
                    }
                  );
                })
                .catch(error => {
                  this.isCodeLoading = false;
                });
            }
          })
          .catch(error => {
            this.isCodeLoading = false;
            if (error.response.status == 404)
              this.$store.commit("showNotice", {
                type: "error",
                desc: "Invalid Code"
              });
          });
      }
    }
  }
};
</script>

